import { styled, Grid, IconButton, Dialog } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  // alignItems: "start",
  "& .MuiFormControl-root": {
    width: "100%",
  },
});

export const SendButton = styled(IconButton)({
  marginTop: "16px",
});

export const PreviousNotesContainer = styled(Grid)(({ theme }) => ({
  borderLeft: `2px solid ${theme.palette.primary.light}`,
  display: "flex",
  flexDirection: "column",
}));

export const StartAdornmentContainer = styled(Grid)({
  display: "flex",
  alignSelf: "start",
  gap: "10px",
  marginRight: "10px",
});

export const EndAdornmentContainer = styled(Grid)({
  display: "flex",
  alignSelf: "start",
  gap: "10px",
});

export const StyledAudio = styled("audio")({
  width: "250px",
  height: "30px",
});

export const SingleNote = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  "& .MuiTypography-root:first-of-type": {
    display: "flex",
    gap: "3px",
    paddingLeft: "15px",
    color: theme.palette.secondary.light,
    alignItems: "baseline",
  },
}));

export const SingleNoteContent = styled(Grid)({
  display: "flex",
  gap: "10px",
  alignItems: "center",
  padding: "0px 25px",
  "& audio": {
    height: "35px",
    "&::-webkit-media-controls-enclosure": {
      borderRadius: "5px",
    },
  },
});

export const FileAudioContainer = styled(Grid)({
  position: "relative",
  "&:hover": {
    "& .MuiIconButton-root": {
      opacity: 1,
    },
  },
});

export const DeleteButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  color: theme.palette.error.main,
  opacity: 0,
  top: 0,
  right: "-7px",
  width: "fit-content",
  height: "fit-content",
}));

export const DocumentViewerContainer = styled(Dialog)(({ theme }) => ({
  width: "99vw",
  maxWidth: "99vw",
  "& .MuiPaper-root": {
    width: "97vw",
    maxWidth: "97vw",
  },
}));
